module.exports = __webpack_public_path__ + "static/media/angle_right.1def1db3.svg";